import React from 'react';

import { TypographyListItem } from 'components/TypographyList';

import { IApproverListItem } from './interfaces';

export const ApproverListItem: React.FC<IApproverListItem> = ({
  name,
  ...props
}) => {
  return (
    <TypographyListItem {...props} type={'none'}>
      {name}
    </TypographyListItem>
  );
};

export default ApproverListItem;
